import React, { useEffect, useState } from "react";
import { useSingleItem } from "../../../_actions/app/items";
import { MessageCodeView } from "../../../ai_home/ChatBox";
import language from "react-syntax-highlighter/dist/esm/languages/hljs/1c";
import TemplateAIInput, {
    CustomizeDBInput,
    removeUsedFields,
    getBlankFilledValues,
    DBInput,
} from "../TemplateAIInput";
import { useGeneratePresetDataWithAI } from "../../../ai_img_gen/post_processing";
import { Button, Divider } from "antd";
import GSBox, { GSModal } from "../GSBox";
import log from "cslog";
import LanguageDD from "./LanguageDD";
import { useBusiness } from "../../../_actions/finance";
import DesignCustomization from "../DesignCustomization";
import LoadingBox from "../../../common/LoadingBox";
import SocialPostingBox from "../../../social_media/SocialPostingBox";

function CustomizerDesign({
    id,
    me,
    isMobile,
    item,
    prefill,
    setPrefill,
    gs_overrides,
    setGSOverrides,
    org,
    setOrg,
    person,
    setPerson,
    lang = "English",
    setLang = () => {},
    isTranslating = false,
    linked_preset_id,
    platforms,
    entry_id,
}) {
    const { isSuccess, isLoading, data } = useSingleItem(
        "qdb_creation_template",
        `/${id}?fields=id,type,title,is_themeable,theme,preview.id,preview.filename_disk,tags.qdb_tag_id.*,inputs,used_schemas.qdb_creation_schema_id.id,used_schemas.qdb_creation_schema_id.name,used_schemas.qdb_creation_schema_id.user_prompt_question,used_schemas.qdb_creation_schema_id.inputs,used_schemas.qdb_creation_schema_id.linked_presets.related_qdb_creation_schema_id.id`,
        !!id,
    );
    const {
        isSuccess: linkedPresetSuccess,
        isLoading: linkedPresetLoading,
        data: linkedPresetData,
    } = useSingleItem(
        "qdb_creation_schema",
        `/${linked_preset_id}?fields=id,inputs,origin_preset.id`,
        !!linked_preset_id,
    );
    // const [prefill, setPrefill] = React.useState({});
    const { updateInputs, isLoading: loadingAIInput } =
        useGeneratePresetDataWithAI((new_prefill) => {
            setPrefill(new_prefill);
        });
    const [user_inputs_filled, setUserInputsFilled] = useState({});

    const [color_theme, setColorTheme] = useState(null);

    // const [gs_values, setGsValues] = useState({
    //     config: {},
    // });

    const slug_field = "id";
    const is_template = true;

    const creation_type = item?.type;
    const inputs = item?.inputs || {};
    const page_id = creation_type === "document" ? "home" : "frontSide";

    const pageInputs = inputs?.[page_id];

    let db_inputs = {};
    if (pageInputs) {
        Object.keys(pageInputs).forEach((key) => {
            const input = pageInputs[key];
            if (input.block_type === "qureal_database") {
                db_inputs[key] = input;
            }
        });
    }

    log.d(item, "item in CustomizerDesign");
    log.d(db_inputs, "db_inputs in CustomizerDesign");
    log.d(prefill, "prefill in CustomizerDesign");
    log.d(user_inputs_filled, "user_inputs_filled in CustomizerDesign");

    // useEffect(() => {
    //     if (item?.data?.gconfig?.gconfig?.colors) {
    //         setGsValues({
    //             config: {
    //                 ...item?.data?.gconfig?.gconfig?.colors,
    //                 ...item?.data?.gconfig?.gconfig?.fontSets,
    //             },
    //         });
    //     }
    // }, [item?.data?.gconfig]);

    if (!isSuccess) {
        // return <p>Loading...</p>;
        return <LoadingBox />;
    }

    return (
        <div>
            {!isMobile && (
                <SocialPostingBox
                    platforms={platforms}
                    entry_id={entry_id}
                    org_id={org}
                />
            )}
            {/* <LanguageDD
                value={lang}
                onChange={(val) => setLang(val)}
                loading={isTranslating}
                minimal={false}
            /> */}
            <DesignCustomization
                me={me}
                // item={item}
                item={data}
                db_inputs={db_inputs}
                isMobile={isMobile}
                platforms={platforms}
                entry_id={entry_id}
                org_id={org}
                org={org}
                setOrg={setOrg}
                person={person}
                setPerson={setPerson}
                prefill={prefill}
                setPrefill={setPrefill}
                // preset={preset}
                preset={null}
                gs_overrides={gs_overrides}
                setGSOverrides={setGSOverrides}
                // bookPrefill={bookPrefill}
                // setBookPrefill={setBookPrefill}
                bookPrefill={null}
                setBookPrefill={() => {}}
                loadingAIInput={loadingAIInput}
                // user_inputs={user_inputs}
                user_inputs={{}}
                // tokenData={tokenData}
                updateInputs={updateInputs}
                slug_field={slug_field}
                is_template={is_template}
                setUserInputsFilled={setUserInputsFilled}
                // one={one}
                // updateOne={updateOne}
                one={{}}
                updateOne={() => {}}
                color_theme={color_theme}
                setColorTheme={setColorTheme}
                lang={lang}
                setLang={setLang}
                isTranslating={isTranslating}
                linkedPresetData={linkedPresetData}
            />

            {/* {true &&
                ["designer", "reviewer"].includes(me?.irole) &&
                Object.keys(db_inputs).map((input_id) => {
                    const input = db_inputs[input_id];
                    return (
                        <>
                            <DBInput
                                record_id={item?.id}
                                input_id={input_id}
                                input_data={input?.data}
                                me={me}
                                isMobile={isMobile}
                                org={org}
                                onOrgChange={(val) => setOrg(val)}
                                onOrgChangeFull={(org_full) => {
                                    const brand_colors =
                                        org_full?.brand_colors || {};
                                    log.d(brand_colors, "brand_colors");
                                    setGSOverrides({
                                        config: brand_colors,
                                    });
                                }}
                                person={person}
                                onPersonChange={(val) => setPerson(val)}
                                prefill={prefill?.[input_id]}
                                setPrefill={(new_values) => {
                                    setPrefill({
                                        ...prefill,
                                        [input_id]: new_values || {},
                                    });
                                }}
                                // preset={preset}
                                preset={null}
                            />
                        </>
                    );
                })} */}

            {/* <GSModal
                initial_values={gs_values}
                values={gs_overrides}
                onChange={(new_values) => {
                    setGSOverrides(new_values);
                }}
            /> */}

            {/* <LanguageDD
                value={lang}
                onChange={(val) => setLang(val)}
                loading={mutationTranslate.isLoading}
            /> */}

            {/* <TemplateAIInput
                inputs={data.inputs}
                used_schemas={data.used_schemas}
                me={me}
                // org={org}
                creation_type={data.type}
                // onOrgChange={(val) => setOrg(val)}
                // person={person}
                // onPersonChange={(val) => setPerson(val)}
                isMobile={isMobile}
                // loadingAI={mutationAIGen.isLoading || loadingAIInput}
                loadingAI={loadingAIInput}
                // user_inputs={user_inputs}
                prefill={prefill}
                setPrefill={setPrefill}
                slug={data[slug_field]}
                is_template={is_template}
                onSubmitInputs={(data) => {
                    // alert("called")
                    // log.d(data, "onSubmitInputs");
                    // updateInputs(data);
                    updateInputs({
                        ...data,
                        // ...(lang !== "English" && { lang }),
                        lang: lang,
                    });
                    setUserInputsFilled(data);
                }}
            /> */}
        </div>
    );
}

export default CustomizerDesign;
